import React from 'react';
import ProductStatus from './single-product-export-status';
import RaisedButton from '../../tc-ui/raised-button-with-loader';
import { Paper } from 'material-ui';

const ExportResults = props => {
  return (
    <Paper style={{ padding: '32px', marginTop: '8px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          {props.exportResponses.products.map((product, index) => <ProductStatus {...product} key={index} />)}
        </div>
        {
                props.state === 'loaded' ? (
                  <span>This contract has been marked as loaded</span>
                ) : (
                  <RaisedButton
                    label="Mark This Contract As Loaded"
                    loader={props.updatingContractState}
                    style={{ margin: '1em 0 1em 1em' }}
                    secondary
                    onClick={() => props.markContractAsLoaded(props.contractId)}
                  />
                )
              }
      </div>
    </Paper>
  );
};
ExportResults.propTypes = {
  exportResponses: React.PropTypes.object,
  state: React.PropTypes.string,
  updatingContractState: React.PropTypes.bool,
  contractId: React.PropTypes.string,
  markContractAsLoaded: React.PropTypes.func,
};
export default ExportResults;



// WEBPACK FOOTER //
// ./src/app/components/integration/export/exportResult.jsx